import { Component, Input, OnInit, Output, EventEmitter, HostListener } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DataProvider } from 'projects/packcert-web/src/app/providers/data.provider';
import { Message, SpinnerService, UtilsService } from 'shared-components';
import { AdminService } from '../../../services/admin.service';
import { saveAs } from 'file-saver';


@Component({
    selector: 'app-upload-file',
    templateUrl: './upload-file.component.html'
})
export class UploadFileComponent implements OnInit {

    private _file;

    public uploadForm: UntypedFormGroup;
    
    public showError: boolean;
    public mensajes = new Array<Message>();

    public filePath: string;

    public showForm = false;

    public dragAreaClass: string;

    private base64String;

    @Input() versionSwId: number;
    @Input() update: boolean;

    @Output() refresh = new EventEmitter<boolean>();
    @Output() refreshReferencia = new EventEmitter<boolean>();
    @Output() mensaje = new EventEmitter<string>();

    constructor(
        private _fb: UntypedFormBuilder,
        private readonly _spinnerService: SpinnerService,
        private readonly _adminService: AdminService
    ) {}

    ngOnInit() {
        this.uploadForm = this._fb.group({
            archivo: [{ value: '', disabled: true }],
            refArchivo: [{ value: '', disabled: true }]
        });
        this.dragAreaClass = 'dragarea';
    }

    @HostListener('dragover', ['$event']) onDragOver(event: any) {
        this.dragAreaClass = 'droparea';
        event.preventDefault();
    }
    @HostListener('dragenter', ['$event']) onDragEnter(event: any) {
        this.dragAreaClass = 'droparea';
        event.preventDefault();
    }
    @HostListener('dragend', ['$event']) onDragEnd(event: any) {
        this.dragAreaClass = 'dragarea';
        event.preventDefault();
    }
    @HostListener('dragleave', ['$event']) onDragLeave(event: any) {
        this.dragAreaClass = 'dragarea';
        event.preventDefault();
    }
    @HostListener('drop', ['$event']) onDrop(event: any) {
        this.dragAreaClass = 'dragarea';
        event.preventDefault();
        event.stopPropagation();
        this.filePath = event.target.value;
        if (event.dataTransfer.files) {
            let files: FileList = event.dataTransfer.files;
            this.saveFiles(files);
        }
    }

    public saveFiles(files: FileList) {
        if (files.length > 1) {
            this.mensajes.push({ class: 'error', message: 'Solo se permite seleccionar un archivo' });
        } else {
            this.convertToBase64(files[0]);
        }
    }

    public onFileChange(event: any) {
        let files: FileList = event.target.files;
        this.saveFiles(files);
    }

    public convertToBase64(file) {
        if (file.type === 'application/x-msdownload') {
            let reader = new FileReader();
            reader.readAsDataURL(file);
            this._spinnerService.showSpinner();
            reader.onload = () => {
                this._spinnerService.hideSpinner();
                this.showForm = true;
                this.base64String = reader.result.toString().replace('data:application/x-msdownload;base64,', '');
                this.uploadForm.patchValue({
                    archivo: file.name,
                    refArchivo: file.name
                });
            };
        } else {
            this.showError = true;
            this.mensajes.push({ class: 'error', message: 'Seleccione un archivo compatible' });
        }
    }

    public save() {
        this.checkForm();
        if (!this.uploadForm.valid) {
            this._file = {
                id: this.versionSwId,
                archivo: this.base64String,
                refArchivo: this.uploadForm.get('refArchivo').value
            };
            this._spinnerService.showSpinner();
            if (this.update) {
                this._adminService.asociaActualizadorBlob(this._file).toPromise().finally(() => {
                    this._spinnerService.hideSpinner();
                }).then((resp) => {
                    this.refresh.emit(true);
                    this.showError = true;
                    this.mensajes.push({ class: 'success', message: 'Archivo Subido Correctamente' });
                }), (error) => {
                    this.showError = true;
                    this.mensaje.emit('global.error.noResponse');
                }
            } else {
                this._adminService.asociaInstaladorBlob(this._file).toPromise().finally(() => {
                    this._spinnerService.hideSpinner();
                }).then((resp) => {
                    this.refresh.emit(true);
                    this.showError = true;
                    this.mensajes.push({ class: 'success', message: 'Archivo Subido Correctamente' });
                }), (error) => {
                    this.showError = true;
                    this.mensaje.emit('global.error.noResponse');
                }
            }
        }
    }

    private checkForm() {
        this.showError = this.uploadForm.invalid;
        if (this.showError) {
            this.mensajes.push({ class: 'error', message: 'global.error.required' });
        }
    }

    public close() {
        this.refresh.emit(false);
    }
}